import { store as singleStore } from './views/single/store';
import { store as unionStore } from './views/union/store';
import { TEMPLATE_MODE } from './constants';

export function resolveStore(userType, code, tpl, mode) {
  if (mode === TEMPLATE_MODE.SINGLE) {
    return singleStore(userType, code, tpl);
  }
  if (mode === TEMPLATE_MODE.UNION) {
    return unionStore(userType, code, tpl);
  }
}
